import { Navigate, Outlet } from "react-router-dom";

import { useAuth } from "@/lib/use-auth";

const LoginLayout = () => {
  const userRole = localStorage.getItem("userRole") as "admin" | "employee";

  const {
    data,
    // isPending,
    // isError, isPending
  } = useAuth();

  // if (isPending) {
  //   return <div>Loading...</div>;
  // }

  // Only redirect if user is authenticated AND userRole is valid
  if (data.success && userRole && (userRole === "admin" || userRole === "employee" || userRole === "superadmin" || userRole === "teamleader")) {
    return <Navigate to={`/${userRole}`} />;
  }

  return (
    <div className="h-full">
      <Outlet />
    </div>
  );
};

export default LoginLayout;
